import clsx from 'clsx';

export const DraftBadge = ({
  isActive,
  className,
}: {
  isActive: boolean;
  // Callers control positioning (e.g. the sidebar right-aligns with "ml-auto");
  // the badge itself stays layout-neutral so it can also sit inline in a row.
  className?: string;
}) => (
  <span
    className={clsx(
      // "bg-secondary-hover" is what is in the design spec, but that's the
      // current "active" sidebar color and updating that is out of scope so
      // this is a "close enough to the design spec" solution for now.
      isActive ? 'bg-gray-100' : 'bg-secondary-hover',
      'text-sm px-2 py-0.5 rounded-md',
      className,
    )}
    data-testid="draft-badge"
  >
    Draft
  </span>
);
